import { onVisibleInViewPort } from '../../../../utils';

type Milliseconds = number;

interface Props {
  delay: Milliseconds;
}

const ANIMATION_DURATION: Milliseconds = 1000;

export function scrollToFilterByKey(filterKey: string | undefined | null, props: Props = { delay: 300 }) {
  if (!filterKey) return;
  setTimeout(() => {
    const element = getElement(filterKey);
    if (!element) return;

    onVisibleInViewPort(element, (thisElement) => {
      thisElement.classList.add(FOCUS_ANIMATION_CLASS_NAME);
      setTimeout(() => {
        getElement(filterKey)?.classList.remove(FOCUS_ANIMATION_CLASS_NAME);
      }, ANIMATION_DURATION);
    });

    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, props.delay);
}

export const FOCUS_ANIMATION_CLASS_NAME = 'animation-focus';

function getElement(filterKey: string) {
  return document
    .querySelector('[data-test="data-table-filters-drawer"] > .MuiPaper-root')
    ?.querySelector(`#data-table-filter-${filterKey}`);
}
